import lazyLoad from '../vendor/lazyload';
import { GNB_FONT } from '../config';

let isCalled = false;

export function loadFont(callback?: () => void): void {
  // 다른 JS(예: 푸터)에서 폰트 로드를 체크하고 싶을 때 사용
  const flag = 'data-web-font-loaded';
  // prettier-ignore
  const fontLoaded = document.body.getAttribute(flag) === 'true';

  if (isCalled || fontLoaded) return;

  isCalled = true;

  lazyLoad.css(GNB_FONT, () => {
    document.body.setAttribute(flag, 'true');

    if (typeof callback === 'function') {
      callback();
    }
  });
}
